import './App.css';
import React from "react";
import { Amplify } from 'aws-amplify';
import { ThemeProvider, useTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import FaceLiveness from './Components/FaceLiveness';
import ReferenceImage from './Components/ReferenceImage';
import Header from './Components/header';
import WrapperChatbot from './Components/chatbot/WrapperChatbot';
import {
  View,
  Flex,
} from '@aws-amplify/ui-react';

import awsexports from './aws-exports';
import { backgroundColor } from './config/config';

Amplify.configure(awsexports);

function App() {

  const [faceLivenessAnalysis, setFaceLivenessAnalysis] = React.useState(null)
  const [chatbotContext, setChatbotContext] = React.useState({ hasError: false, errorCode: undefined })

  const getfaceLivenessAnalysis = (faceLivenessAnalysis) => {
    if (faceLivenessAnalysis !== null) {
      setFaceLivenessAnalysis(faceLivenessAnalysis)
    }
  }

  const tryagain = () =>{
    setFaceLivenessAnalysis(null)
  }

  const { tokens } = useTheme();
  const theme = {
    name: 'custom-button-theme',
    tokens: {
      components: {
        button: {
          // this will affect the font weight of all Buttons
          fontWeight: { value: '{fontWeights.black.value}' },
          // this will only style Buttons which are the "primary" variation
          primary: {
            backgroundColor: { value: backgroundColor },
            _hover: {
              backgroundColor: { value: 'hotpink' },
            },
          },
        },
      },
      colors: {
        background: {
          primary: {
            value: '#fff',
          },
        },
          font: {
            primary: {
              value: tokens.colors.white.value,
            },
        },
      },
      message: {
        outlined: {
          warning: {
            color: '{colors.pink.100}',
            backgroundColor: '{colors.pink.10}',
            borderColor: '{colors.pink.100}',
          },
          success: {
            color: {value: '#389E0D'},
          },
        },
        filled: {
          warning: {
            backgroundColor: '{colors.teal.10}',
            color: '{colors.teal.90}',
          },
          success: {
            color: {value: '#389E0D'},
          },
        },
      },
    },
  };


  return (
    <ThemeProvider theme={theme}>
      <Flex
        direction="row"
        justifyContent="center"
        alignItems="center"
        alignContent="flex-start"
        wrap="nowrap"
        gap="1rem"
      >
        <View
          as="div"
          width="740px"
          maxWidth="740px"
          style={{zIndex:10000}}
        >
          <Header/>
        </View>
      </Flex>
      <WrapperChatbot hasError={chatbotContext.hasError} errorCode={chatbotContext.errorCode} />
          {faceLivenessAnalysis && faceLivenessAnalysis.Confidence ? (
            <ReferenceImage faceLivenessAnalysis={faceLivenessAnalysis} tryagain={tryagain}></ReferenceImage>
          ) :
            (<FaceLiveness faceLivenessAnalysis={getfaceLivenessAnalysis} onChatbotContextChange={setChatbotContext} />)}
          
    </ThemeProvider>


  );
}

export default App;
